import React, { useState, useEffect } from "react";
import { GoogleMap, useLoadScript, Marker, InfoWindow } from "@react-google-maps/api";
import { mapStyles } from "../map/google/constants"; // Custom map styles
import marker_icon from "./images/map-marker-white.svg"
import HTMLReactParser from 'html-react-parser';
// import { MarkerIcon } from '../map/icon';
import { Link } from "@StarberryUtils";
import _ from "lodash";
import "../map/styles/_index.scss";
import { connectInfiniteHits } from "react-instantsearch-core";

const containerStyle = {
  width: "100%",
  height: "100%",
};

const defaultCenter = { lat: 25.276987, lng: 55.296249 };

function MapsInfiniteHits(props) {
  const [mapMarkers, setMapMarkers] = useState([]);
  const [currentId, setCurrentId] = useState("");
  const [prevHits, setPrevHits] = useState([]);
  const [render, setRender] = useState(false);
  const [center, setCenter] = useState(defaultCenter);
  const [zoom, setZoom] = useState(11);

  const { isLoaded } = useLoadScript({
    googleMapsApiKey: process.env.GATSBY_MAPS_API_KEY,
  });

  let data = _.cloneDeep(props.hits);

  if (_.isEmpty(data)) {
    data = props.propertyData.filter((x) => x.status !== "Sold" && x.status !== "Rented");
    if (props.type && props.propertyTypeData.length > 0) {
      data = props.propertyTypeData.filter((x) => x.status !== "Sold" && x.status !== "Rented");
    }

    data.forEach((vals) => {
      vals.objectID = vals.id;
      vals["_geoloc"] = {
        lat: vals?.latitude,
        lng: vals?.longitude,
      };
    });
  }
 // Generate URL based on department and search_type
 const generateUrl = (marker) => {
  const { department, search_type, slug, objectID} = marker;
  let basePath = "/";

  if (department === "residential") {
    basePath += search_type === "sales" ? "properties-for-sale" : "properties-for-rent";
  } else if (department === "commercial") {
    basePath +=
      search_type === "sales"
        ? "commercial-properties-for-sale"
        : "commercial-properties-for-rent";
  }

  return `${basePath}/${slug}-${objectID}`;
};
const getPOA = (poa, price) => {
  var permit = 'AED ' + price.toLocaleString();
  if (!_.isEmpty(poa)) {
    if (poa == "Y") {
      permit = "PRICE ON APPLICATION";
    }
  }
  return permit;
}
  // Effect to process and update markers
  useEffect(() => {
    if (!_.isEqual(prevHits, data)) {
      setPrevHits(_.cloneDeep(data));
      setRender(false);
      const mapMarkersArray = _.cloneDeep(data);

      if (data.length <= 0) {
        mapMarkersArray.push(
          { objectID: "noProp", _geoloc: { lat: 25.0757595, lng: 54.947555 } },
          { objectID: "noProp", _geoloc: { lat: 25.075464, lng: 55.1374563 } }
        );
      }

      if (mapMarkersArray.length <= 4) {
        if (mapMarkersArray[0]?._geoloc) {
          mapMarkersArray.push(
            { objectID: "noProp", _geoloc: { lat: parseFloat(mapMarkersArray[0]._geoloc.lat) + 0.002, lng: parseFloat(mapMarkersArray[0]._geoloc.lng) + 0.002 } },
            { objectID: "noProp", _geoloc: { lat: parseFloat(mapMarkersArray[0]._geoloc.lat) - 0.003, lng: parseFloat(mapMarkersArray[0]._geoloc.lng) - 0.003 } }
          );
        } else {
          mapMarkersArray.push(
            { objectID: "noProp", _geoloc: { lat: 25.0757595, lng: 54.947555 } },
            { objectID: "noProp", _geoloc: { lat: 25.075464, lng: 55.1374563 } }
          );
        }
      }
      setMapMarkers(mapMarkersArray);
      setTimeout(() => setRender(true), 200);
    }
  }, [data, prevHits]);

  // Function to fit bounds to markers
  const fitBoundsToMarkers = (map) => {
    const bounds = new window.google.maps.LatLngBounds();
    mapMarkers.filter((marker) => !_.isEmpty(marker._geoloc)).forEach((marker) => {
      bounds.extend(new window.google.maps.LatLng(marker._geoloc.lat, marker._geoloc.lng));
    });

    if (!bounds.isEmpty()) {
      map.fitBounds(bounds);
    }
  };

  // Callback when map is loaded
  const handleMapLoad = (map) => {
    if (mapMarkers.length > 0) {
      fitBoundsToMarkers(map);
    }
  };

  if (!isLoaded) return <div>Loading...</div>;

  return (
    <div id="map" className="map">
      {render && (
        <GoogleMap
          mapContainerStyle={containerStyle}
          center={center}
          zoom={zoom}
          options={{
            styles: mapStyles,
            disableDefaultUI: true,
            zoomControl: true, 
          }}
          onLoad={handleMapLoad}
        >
          {mapMarkers
            .filter((marker) => !_.isEmpty(marker._geoloc))
            .map((marker, index) => (
              <Marker
                key={index}
                position={{
                  lat: marker._geoloc.lat,
                  lng: marker._geoloc.lng,
                }}
                icon={{
                  url: marker_icon,
                  scaledSize: new window.google.maps.Size(30, 30),
                }}
                onClick={() => setCurrentId(marker.objectID)}
              >
                {currentId === marker.objectID && (
                  <InfoWindow onCloseClick={() => setCurrentId("")}>
                    <div className="marker-tooltip-wrap">

                    {!_.isEmpty(marker.images) && (
                      <div className="marker-image img-zoom">
                       <Link href={generateUrl(marker)}> 
                        <img
                          loading="lazy"
                          src={marker.images[0]['425x300']}
                          alt={marker.title}
                          width="100%"
                        />
                        </Link>
                      </div>
                    )}
                    <div className="marker-info">
                          <h6 className="h7"><Link href={generateUrl(marker)}>{marker.title}</Link></h6>
                          {marker.display_address && (
                            <>
                              <div className="marker-address text-xs">
                                {HTMLReactParser(marker.display_address.replace(/<br\s*\/?>/gi, ''))}
                              </div>
                              <div class="price text-md-bold-20-16"> {getPOA(marker.poa, marker.price)}</div>                         
                              <Link href={generateUrl(marker)} className="map-view-link text-sm-bold">View Details</Link>
                            </>
                          )}
                    </div>
                    </div>
                  </InfoWindow>


                )}
              </Marker>
            ))}
        </GoogleMap>
      )}
    </div>
  );
}

const MapContainer = connectInfiniteHits(MapsInfiniteHits);

export default React.memo(MapContainer);